import { shouldForwardProp } from '@ori/presentation-utils';
import { styled } from '@ori-ui/mui';
export var ImageWrapper = styled('div', {
  name: 'ImageWrapper',
  shouldForwardProp: shouldForwardProp()
})(function () {
  return {
    display: 'flex',
    img: {
      height: '100%',
      width: '100%'
    }
  };
});
//# sourceMappingURL=styles.js.map